module.exports = "https://syscdn.233leyuan.com/fw/activemodal/1625144333412/static/img/icon-wait.ab349dd2.png";